export default __webpack_public_path__ + "static/media/quiz-ending-happy.e54ecda1.svg";